import React from 'react';
import RangePicker from '../../../../shared/Point/Filters/RangePicker/RangePicker';

const Period = ({
    periods,
    rangePeriod,
    selectedPeriod,
    setSelectedPeriod,
    bettingHistory,
    setBettingHistory,
    clearData,
    onBetHistoryPeriodChange,
    onSearch,
}) => {
    const { startTime, endTime } = bettingHistory;

    const onPeriodChange = period => {
        setSelectedPeriod(period);

        if (period.key === rangePeriod.key) {
            onBetHistoryPeriodChange({ startTime: null, endTime: null });
        } else {
            const { startTime, endTime } = period.getRange();
            onBetHistoryPeriodChange({ startTime, endTime });
        }
    };

    const handleDateChange = (date, callback) => {
        if (date) {
            clearData();
            setSelectedPeriod(rangePeriod);
            callback();
        }
    };

    const onStartDateChange = date => {
        handleDateChange(date, () => {
            date.setHours(0, 0, 0, 0);
            setBettingHistory(prev => ({ ...prev, startTime: date.getTime() }));
        });
    };

    const onEndDateChange = date => {
        handleDateChange(date, () => {
            date.setHours(23, 59, 59, 999);
            setBettingHistory(prev => ({ ...prev, endTime: date.getTime() }));
        });
    };

    return (
        <RangePicker
            periods={periods}
            selectedPeriod={selectedPeriod}
            onPeriodChange={onPeriodChange}
            startDate={startTime}
            endDate={endTime}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            onSearch={onSearch}
            showTime
        />
    );
};

export default Period;
